var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4401 22.8066C10.0384 22.2019 8.05565 20.8238 6.49167 18.6724C4.92768 16.521 4.14604 14.1325 4.14673 11.507V5.1833L12.4401 2.0733L20.7334 5.1833V11.507C20.7334 14.1332 19.9517 16.522 18.3884 18.6734C16.8251 20.8249 14.8424 22.2026 12.4401 22.8066ZM12.4401 20.6296C14.2369 20.0594 15.7228 18.9191 16.8977 17.2086C18.0726 15.4981 18.66 13.5976 18.66 11.507V6.60871L12.4401 4.27622L6.22006 6.60871V11.507C6.22006 13.5976 6.8075 15.4981 7.98239 17.2086C9.15728 18.9191 10.6432 20.0594 12.4401 20.6296Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionIcon);
export default __webpack_public_path__ + "static/media/ProtectionIcon.fee3392bde1172cb4c771aacdab3b5c3.svg";
export { ForwardRef as ReactComponent };